<template>
    <div class="container-fluid" style="margin-top: 5%;">
        <v-row justify="center">
            <v-col class="py-0">
                <v-row class="py-0">
                    <v-col class="pl-3">
                        <v-row>
                            <v-col class="py-0" style="line-height: 20px; padding: 0% 5% 0% 5%;">
                                <v-row :style="`color:${danger}`">
                                    <v-col md="1" cols="12"></v-col>
                                    <v-col md="10" cols="12" style="text-align: center;">
                                        <h2>{{ $t('unPaidRegistration.payment.warning') }}</h2>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col md="1" cols="12"></v-col>
                                    <v-col md="10" cols="12" style="text-align: center;">
                                        {{ event.platformName == 'Stripe' ? $t('unPaidRegistration.payment.text_stripe_1') : $t('unPaidRegistration.payment.text1') }}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col md="1" cols="12"></v-col>
                                    <v-col md="10" cols="12" style="text-align: center;">
                                        {{ $t('unPaidRegistration.payment.text2') }}
                                    </v-col>
                                </v-row>
                                <v-row justify="center" style="margin-bottom:5px;">
                                   <h2>{{ $t('unPaidRegistration.payment.time') }}</h2>
                                </v-row>
                                <v-row justify="center" style="margin-bottom:10px;margin-top:10px;">
                                    <v-progress-circular
                                        :rotate="360"
                                        :size="100"
                                        :width="15"
                                        :value="value"
                                        color="primary"
                                    >
                                    {{ hours }}:{{ minutes }}:{{ seconds }}
                                    </v-progress-circular>
                                </v-row>
                                <br>
                                <v-row justify="center">
                                    <v-expansion-panels accordion multiple :value="[0]" style="width:90%;">
                                        <v-expansion-panel
                                            style="margin-bottom: 10px;">
                                            <v-expansion-panel-header
                                                class="my-1"
                                                :style="`background-color: ${navigationBGColor} !important;`"
                                                dark>
                                                <p depressed
                                                class="font-weight-bold text-left white--text text-uppercase"
                                                style="color: #fff !important; margin-bottom:0px"
                                                >{{ event.eventDate }} :: {{ event.eventName}}</p>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>

                                                <v-expansion-panels accordion multiple :value="[0]">
                                                    <v-expansion-panel>
                                                        <v-expansion-panel-header
                                                            class="my-1"
                                                            :style="`background-color: ${navigationBGColor} !important`"
                                                            dark>
                                                            <p depressed
                                                            class="font-weight-bold text-left white--text text-uppercase"
                                                            style="color: #fff !important; margin-bottom:0px"
                                                            >{{ $t('unPaidRegistration.transaction_summary') }}</p>
                                                        </v-expansion-panel-header>
                                                        <v-expansion-panel-content>
                                                            <Summary :platformName="event.platformName" :eventId="eventId" :discount="event.idCoupon ? event : null" @summaryItems="getSummaryItems"></Summary>
                                                        </v-expansion-panel-content>
                                                    </v-expansion-panel>
                                                </v-expansion-panels>

                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
        </v-col>
        </v-row>
    </div>
</template>

<script>
import Summary from "../components/unPaidRegistration/Summary.vue";
import PaymentService from "../services/PaymentService";
import AuthService from "../services/AuthService";
import { VRow, VCol, VExpansionPanels, VExpansionPanel, VExpansionPanelHeader, VExpansionPanelContent, VProgressCircular } from 'vuetify/lib';

export default {
    components: {
        Summary,
        VRow,
        VCol,
        VExpansionPanels,
        VExpansionPanel,
        VExpansionPanelHeader,
        VExpansionPanelContent,
        VProgressCircular
    },
    data() {
        return {
            danger: null,
            summaryItems: [],
            userId: null,
            buttonColor: null,
            navigationBGColor: null,
            QueueId: null,
            hours: '00',
            minutes: '00',
            seconds: '00',
            regId: null,
            eventId: null,
            event: [],
            timer: null,
            value: 100,
            subValue: null
        }
    },
    methods: {
        getSummaryItems(summaryItems) {
            this.summaryItems = summaryItems.registrants ? summaryItems.registrants : [];
        },
        async countDownTimer() {

            if(this.seconds > 0) {
                setTimeout(() => {
                    this.seconds -= 1;
                    this.value -= this.subValue;

                    if(this.seconds < 10)
                        this.seconds = "0" + this.seconds;

                    this.countDownTimer()
                }, 1000)
            } else if(this.seconds == 0 && this.minutes > 0){
                setTimeout(() => {
                    if(this.minutes > 0){
                        this.seconds = 59;
                    }
                    this.minutes -= 1;

                    if(this.minutes < 10)
                        this.minutes = "0" + this.minutes;

                    this.countDownTimer()
                }, 1000)

            } else if(this.seconds == 0 && this.minutes == 0 && this.hours > 0){
                setTimeout(() => {
                    if(this.hours > 0){
                        this.minutes = 60;
                    }

                    this.hours -= 1;

                    if(this.hours < 10)
                        this.hours = "0" + this.hours;

                    this.countDownTimer()
                }, 1000)
            }

            if(this.hours == 0 && this.minutes == 0 && this.seconds == 0 && (this.$route.name == 'Payment' || this.$route.name == 'PaymentDashboard')){

                const buddies = this.summaryItems.filter((el) => {
                    return el.checked;
                }).map((el) => {
                    return el.id;
                }).toString();
                
                if(this.event.platformName == 'Stripe'){
                    const response = await fetch(`${this.$store.getters.env.get('VUE_APP_DEV_API_HOST')}/laravel/public/api/v1/livelaps/stripe/eventRegistrationPayment/${this.regId}${buddies ? `?buddies=${buddies}` : ''}`);
                    const data = await response.json();                        
                    if (data.url) {
                        window.location.href = data.url;
                    } 
                } else {
                    if(buddies != ''){
                        window.location.href = `${this.$store.getters.env.get('VUE_APP_DEV_API_HOST')}/laravel/public/api/v1/livelaps/eventRegistrationPayment/${this.regId}?buddies=${buddies}`;
                    } else {    
                        window.location.href = `${this.$store.getters.env.get('VUE_APP_DEV_API_HOST')}/laravel/public/api/v1/livelaps/eventRegistrationPayment/${this.regId}`;
                    }
                }
            }

        },
        async getQueueTimer(){

            var hours = Math.floor(this.timer / 60 / 60);
            var minutes = Math.floor(this.timer / 60) - (hours * 60);
            var seconds = this.timer % 60;

            if(hours < 10)
                this.hours = "0" + hours;
            else
                this.hours = hours;

            if(minutes < 10)
                this.minutes = "0" + minutes;
            else
                this.minutes = minutes;

            if(seconds < 10)
                this.seconds = "0" + seconds;
            else
                this.seconds = seconds;

            this.subValue = 100/this.timer;
            this.countDownTimer();
        },
        async getUser(){
            await AuthService.getUserCurrent().then(response => {
                if (response.data.success == 1) {
                    this.userId = response.data.message.id;
                    this.getUnpaid();
                }
            });
        },
        async getUnpaid() {
            await PaymentService.unpaid(this.userId).then(response => {
                if(response.data.success == 1){
                    var menu = response.data.message;
                    menu.filter(item =>{
                        if(item.id == this.regId)
                           this.event = item;
                        })
                    
                    this.getQueueTimer();
                }
            });
        }
    },
    created: function() {
        this.navigationBGColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
        this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
        this.danger = this.$store.getters.env.get('VUE_APP_BUTTON_DANGER_COLOR');
        this.regId = this.$route.query.regId;
        this.eventId = this.$route.query.eventId;
        this.timer = this.$route.query.timer;
        
        this.getUser();
    }
};
</script>
<style>
.grayC {
  background: #ccc;
}
.btn_next{
  color: white !important;
}
</style>